// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cost-breakdown .header {
  background: var(--grey);
  display: flex;
  gap: 30px;
  padding-left: 14%;
  padding-right: 14%;
  padding-top: 50px;
  padding-bottom: 50px;
}
.full-cost-breakdown {
  padding-left: 14%;
  margin-top: 50px;
  position: relative;
}
.full-cost-breakdown h1 {
  font-size: 36px;
  font-weight: 500;
  line-height: 50px;
  margin-bottom: 25px;
}
.full-cost-breakdown p,
.cost-breakdown .notes {
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  text-align: left;
  margin-bottom: 62px;
}
.cost-breakdown .notes {
  margin-bottom: 16px;
}
.cost-breakdown .notes {
  width: 66.5%;
  padding-left: 14%;
}
.full-cost-breakdown.total-amount {
  margin-top: 78px;
  margin-bottom: 18px;
}
.proceed-btn {
  margin-top: 30px;
  margin-bottom: 50px;
  margin-left: 14%;
  width: 186px;
  height: 52px;
  border-radius: 100px;
  background: var(--orange);
  outline: none;
  border: none;
  font-size: 16px;
  font-weight: 700;
  line-height: 20.16px;
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}
.back-btn {
  transform: rotate(90deg);
  margin-top: 3px;
}
.previous-page {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 10px 14%;
  background: var(--grey);
}
.previous-page p {
  font-size: 14px;
  font-weight: 500;
}
.byod-note {
  display: flex;
  align-items: self-start;
}
.byod-info {
  height: 40px;
  width: 40px;
  margin-top: -12px;
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/costBreakdown/costBreakDown.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".cost-breakdown .header {\n  background: var(--grey);\n  display: flex;\n  gap: 30px;\n  padding-left: 14%;\n  padding-right: 14%;\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n.full-cost-breakdown {\n  padding-left: 14%;\n  margin-top: 50px;\n  position: relative;\n}\n.full-cost-breakdown h1 {\n  font-size: 36px;\n  font-weight: 500;\n  line-height: 50px;\n  margin-bottom: 25px;\n}\n.full-cost-breakdown p,\n.cost-breakdown .notes {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  text-align: left;\n  margin-bottom: 62px;\n}\n.cost-breakdown .notes {\n  margin-bottom: 16px;\n}\n.cost-breakdown .notes {\n  width: 66.5%;\n  padding-left: 14%;\n}\n.full-cost-breakdown.total-amount {\n  margin-top: 78px;\n  margin-bottom: 18px;\n}\n.proceed-btn {\n  margin-top: 30px;\n  margin-bottom: 50px;\n  margin-left: 14%;\n  width: 186px;\n  height: 52px;\n  border-radius: 100px;\n  background: var(--orange);\n  outline: none;\n  border: none;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20.16px;\n  color: var(--white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n.back-btn {\n  transform: rotate(90deg);\n  margin-top: 3px;\n}\n.previous-page {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 10px 14%;\n  background: var(--grey);\n}\n.previous-page p {\n  font-size: 14px;\n  font-weight: 500;\n}\n.byod-note {\n  display: flex;\n  align-items: self-start;\n}\n.byod-info {\n  height: 40px;\n  width: 40px;\n  margin-top: -12px;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
